export default __webpack_public_path__ + "dist/media/Check-green.2e614b38.svg";